/**
 * @param $form {jQuery} - The forms needs to be initialized with new Abide($form).
 * @returns {boolean}
 */
module.exports = function isFoundationFormValid($form) {
    if ('foundation' in $form && typeof $form.foundation === 'function') {
        $form.foundation('validateForm');
        return $form.find('[data-form-error-for]:visible').length === 0;
    }

    return true;
}